import React from 'react'
import * as AiIcons from "react-icons/ai";
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import MemoryRoundedIcon from '@mui/icons-material/MemoryRounded';
import VpnKeyRoundedIcon from '@mui/icons-material/VpnKeyRounded';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';


// function navTopic(props){
//     props?a:b

// }
// export default navTopic

export const SidebarData=[
    {  
        title:'Home',
        path: '/home',
        icon:<AiIcons.AiFillHome />,
        cName:'nav-text'
    },
    
    {
        title:'Dashboard',
        path: '/dashboard',
        icon:<DashboardRoundedIcon />,
        cName:'nav-text'
    },
    {
        title:'Hardwares',
        path: '/hardwares',
        icon:<MemoryRoundedIcon />,
        cName:'nav-text'
    },
    {
        title:'Licenças',
        path: '/licenses',
        icon:<VpnKeyRoundedIcon />,
        cName:'nav-text'
    },
    {
        title:'Requisitar \n hardware/licença',
        path: '/suport',
        icon:<LocalMallIcon/>,
        cName:'nav-text'
    },
    {
        title:'Logout',
        path: '/logout',
        icon:<LogoutIcon/>,
        cName:'nav-text'
        
    }
    ]

    export const SidebarDataAdmin=[
// {  
//     title:'Home',
//     path: '/home',
//     icon:<AiIcons.AiFillHome />,
//     cName:'nav-text'
// },
// {  
//     title:'Admin',
//     path: '/admin',
//     icon:<AdminPanelSettingsIcon/>,
//     cName:'nav-text'
// },

// {
//     title:'Dashboard',
//     path: '/dashboard',
//     icon:<DashboardRoundedIcon />,
//     cName:'nav-text'
// },
{
    title:'Hardware',
    path: '/hardware',
    icon:<MemoryRoundedIcon />,
    cName:'nav-text'
},
{
    title:'Licenças',
    path: '/licenses',
    icon:<VpnKeyRoundedIcon />,
    cName:'nav-text'
},
// {
//     title:'Requisitar \n hardware/licença',
//     path: '/suport',
//     icon:<LocalMallIcon/>,
//     cName:'nav-text'
// },
{
    title:'Logout',
    path: '/logout',
    icon:<LogoutIcon/>,
    cName:'nav-text'
    
}
]
export const SidebarDatafalse=[
    { 
        title:'Home',
        path: '/home',
        icon:<AiIcons.AiFillHome />,
        cName:'nav-text'
    },
    { 
        title:'Login',
        path: '/login',
        icon:<LoginIcon />,
        cName:'nav-text'
    },
]